/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Whether the customer-specific pricing we set up with this carrier is
 * actually moving freight. Their own agreements only.
 *
 * @export
 * @interface PerformanceCspUtilisation
 */
export interface PerformanceCspUtilisation {
  /**
   *
   * @type {number}
   * @memberof PerformanceCspUtilisation
   */
  liveAgreements: number;
  /**
   * Of those, how many had a shipment booked under them in the period.
   * @type {number}
   * @memberof PerformanceCspUtilisation
   */
  shippingAgreements: number;
  /**
   * shipping / live. Absent rather than zero when there are no live
   * agreements — a carrier with no CSP accounts has no utilisation, not
   * 0%.
   *
   * @type {number}
   * @memberof PerformanceCspUtilisation
   */
  utilisationRate?: number;
}

/**
 * Check if a given object implements the PerformanceCspUtilisation interface.
 */
export function instanceOfPerformanceCspUtilisation(
  value: object,
): value is PerformanceCspUtilisation {
  if (!("liveAgreements" in value) || value["liveAgreements"] === undefined)
    return false;
  if (
    !("shippingAgreements" in value) ||
    value["shippingAgreements"] === undefined
  )
    return false;
  return true;
}

export function PerformanceCspUtilisationFromJSON(
  json: any,
): PerformanceCspUtilisation {
  return PerformanceCspUtilisationFromJSONTyped(json, false);
}

export function PerformanceCspUtilisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceCspUtilisation {
  if (json == null) {
    return json;
  }
  return {
    liveAgreements: json["liveAgreements"],
    shippingAgreements: json["shippingAgreements"],
    utilisationRate:
      json["utilisationRate"] == null ? undefined : json["utilisationRate"],
  };
}

export function PerformanceCspUtilisationToJSON(
  json: any,
): PerformanceCspUtilisation {
  return PerformanceCspUtilisationToJSONTyped(json, false);
}

export function PerformanceCspUtilisationToJSONTyped(
  value?: PerformanceCspUtilisation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    liveAgreements: value["liveAgreements"],
    shippingAgreements: value["shippingAgreements"],
    utilisationRate: value["utilisationRate"],
  };
}
